import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

type Props = {
  value: 'current' | 'selective' | 'all';
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function SiteAnalysisSelector({ value, onChange }: Props) {
  return (
    <FormControl component='fieldset' sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
      <FormLabel
        id='row-radio-buttons-group-label'
        sx={{
          color: 'text.primary',
          '&.Mui-focused': { color: 'text.primary' },
        }}>
        Utfør analyse i:
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='row-radio-buttons-group'
        value={value}
        onChange={onChange}>
        <FormControlLabel value='current' control={<Radio />} label='Nåværende site' />
        <FormControlLabel value='selective' control={<Radio />} label='Utvalgte siter' />
        <FormControlLabel value='all' control={<Radio />} label='Alle siter' />
      </RadioGroup>
    </FormControl>
  );
}
